export default __webpack_public_path__ + "static/media/know-customers-ar.41d65d3c.png";